<template>
    <!-- Modal -->
    <div id="confirmation-modal">
        <div id="listing-modal-wrapper">
            <div id="logout-modal-wrapper">
                <div class="modal fade show"
                     tabindex="-1" role="dialog"
                     aria-labelledby="exampleModalCenterTitle"
                     aria-hidden="true"
                     style="display: block"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4>{{ $t('messages.success') }}</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span class="close-span" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="confirmation-modal-body modal-body">
                                <div id="modal-buttons">
                                    <button type="button"
                                            class="btn btn-primary"
                                            @click="redirectToMain"
                                    >
                                        {{ $t('goToMain') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SuccessModal from './SuccessModal';
export default SuccessModal;
</script>
